import React from 'react';
import SEO from '../components/SEO';

export default function CookiesPage() {
  return (
    <div data-testid="cookies-page">
      <SEO
        title="Cookies Policy"
        description="How Glossop & District Round Table 916 uses cookies to improve your experience on our website."
        path="/policies/cookies"
        keywords={['cookies policy', 'website cookies', 'Glossop Round Table cookies']}
      />

      <div className="pt-28 sm:pt-32 pb-20 sm:pb-28 bg-white min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Website Policy</span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] mb-8">
            Cookies Policy
          </h1>
          <p className="text-base text-[#52525B] leading-relaxed mb-6 italic">
            How we use cookies to improve your experience
          </p>

          <div className="space-y-8 text-base text-[#52525B] leading-relaxed">
            <div>
              <h3 className="text-lg font-bold text-[#0A0A0A] mb-3">Overview</h3>
              <p>
                Glossop & District Round Table 916 takes your privacy very seriously and respects the importance of security on the internet. Our website uses cookies and similar technologies for various purposes. By continuing to use our website, you agree to our Cookie Policy.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">What are cookies?</h2>
              <p>
                A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you or your computer agrees, the file is added. The cookie helps us analyse website traffic and lets you know when you visit a site. Cookies allow web applications to respond to you as an individual, tailoring operations to your needs, likes and dislikes by gathering and remembering information about your preferences.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Types of Cookies We Use</h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-bold text-[#0A0A0A] mb-2">Strictly Necessary Cookies</h3>
                  <p>These cookies are essential in order to enable you to move around our website and use its features, such as accessing secure areas of our website.</p>
                </div>

                <div>
                  <h3 className="text-lg font-bold text-[#0A0A0A] mb-2">Performance/Analytical Cookies</h3>
                  <p>These cookies collect information about how you use our website. They allow us to recognise and count the number of visitors and how visitors engage with our website. These cookies do not identify you. All information they collect is aggregated and therefore anonymous. We use these cookies to measure and analyse how visitors use our website and to improve its functionality and user experience.</p>
                </div>

                <div>
                  <h3 className="text-lg font-bold text-[#0A0A0A] mb-2">Functionality Cookies</h3>
                  <p>These are used to recognise you when you return to our website. This enables us to personalise our content for you and remember your preferences.</p>
                </div>

                <div>
                  <h3 className="text-lg font-bold text-[#0A0A0A] mb-2">Targeting & Advertising Cookies</h3>
                  <p>These cookies record your visit to our website, the pages you have visited and the links you have followed. We will use this information to make our website more relevant to your interests.</p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Social Media Buttons & Plugins</h2>
              <p>
                We use social media buttons and/or plugins on our site that allow you to connect with our social networks. For these to work, social media sites including Facebook, LinkedIn and Twitter will set cookies through our site which may be used to enhance your profile on their site or contribute to the data they hold for various purposes outlined in their respective privacy policies.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">How We Use Cookies</h2>
              <p>
                We use cookies to help us improve our website's usability and for marketing purposes. We may also use cookies to identify which pages are being used. This helps us analyse data about webpage traffic and improve our website in order to tailor it to visitor needs. We only use this information for statistical purposes.
              </p>
            </div>

            <div className="p-6 bg-[#F4F4F5] border-l-4 border-[#F0A500]">
              <h3 className="text-lg font-bold text-[#0A0A0A] mb-2">Contact Us</h3>
              <p>
                If you have any questions about our Cookie Policy, you can contact us at{' '}
                <a href="mailto:info@glossoproundtable.org" className="text-[#F0A500] hover:text-[#D99500] font-semibold transition-colors">
                  info@glossoproundtable.org
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
